import { createSlice } from '@reduxjs/toolkit';
import {
  defaultLocalizationListFilter,
  defaultLocalizationListColumnVisibility,
  localizationListColumnVisibilityOptions,
} from '@utils/tables/localizations/localizationsListFilter';

// Type
const initialState = {
  currentLocalizations: ['en'],
  localizationTableFilters: {},
  showCreateLanguageDialog: false,
  showCreateLocalizationKeyDialog: false,
  selectedFilters: defaultLocalizationListFilter,
  columnVisibility: defaultLocalizationListColumnVisibility,
  columnVisibilityOptions: localizationListColumnVisibilityOptions,
};

const localizationSlice = createSlice({
  name: 'localization',
  initialState,
  reducers: {
    setCurrentLocalizations: (state, { payload }) => {
      state.currentLocalizations = payload;
    },
    setLocalizationTableFilters: (state, { payload }) => {
      state.localizationTableFilters = payload;
    },
    setColumnVisibility: (state, { payload }) => {
      state.columnVisibility = payload;
    },
    setShowCreateLocalizationKeyDialog: (state, { payload }) => {
      state.showCreateLocalizationKeyDialog = payload;
    },
    setShowCreateLanguageDialog: (state, { payload }) => {
      state.showCreateLanguageDialog = payload;
    },
  },
  extraReducers: {},
});

export const { reducer: localizationReducer } = localizationSlice;
export const {
  setColumnVisibility,
  setCurrentLocalizations,
  setLocalizationTableFilters,
  setShowCreateLanguageDialog,
  setShowCreateLocalizationKeyDialog,
} = localizationSlice.actions;
